import { SpinResponse } from '@cgs/data-access';
import {
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  GameStateMachine,
  IGameStateMachineProvider,
  ResourcesComponent,
  RESOURCES_COMPONENT_TOKEN,
} from '@cgs/machines';
import { Container, TextSceneObject } from '@cgs/wge';
import { TrifectaFreeSpinsCountComponent } from '@cgs/provider-trifecta';

const enum SceneNames {
  TotalText = 'fs_amount',
}

export class CorsicaFreeSpinsComponent extends TrifectaFreeSpinsCountComponent {
  private readonly gameStateMachine: GameStateMachine<SpinResponse>;
  private readonly freeSpinsCountScene: TextSceneObject[];

  constructor(container: Container) {
    super(container);

    this.gameStateMachine = container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;

    this.freeSpinsCountScene = container
      .resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN)
      .slot.findAllById(SceneNames.TotalText)!;

    this.gameStateMachine.accelerate.entered.listen(() => this.decreaseCount());
    this.gameStateMachine.stop.entered.listen(() => this.updateCount());
    this.gameStateMachine.freeSpinsRecovery.entered.listen(() =>
      this.showFreeSpinsAndUpdateCount()
    );
    this.gameStateMachine.beginFreeSpinsPopup.entered.listen(() =>
      this.showFreeSpinsAndUpdateCount()
    );
    this.gameStateMachine.regularSpins.entered.listen(() => this.hideFreeSpins());
  }

  private decreaseCount(): void {
    const count = this.gameStateMachine.curResponse.freeSpinsInfo?.currentFreeSpinsGroup?.count;

    if (!this.gameStateMachine.curResponse.isFreeSpins || !count) {
      return;
    }

    const newCount = count - 1;
    this.freeSpinsCountScene.forEach((text) => (text.text = newCount.toString()));
    this.setFreeSpins(newCount);
  }

  private showFreeSpinsAndUpdateCount(): void {
    this.showFreeSpins();
    this.updateCount();
  }

  private updateCount(): void {
    if (!this.gameStateMachine.curResponse.isFreeSpins) {
      this.freeSpinsCountScene.forEach((text) => (text.text = '0'));
      this.setFreeSpins(0);
      return;
    }

    const count =
      this.gameStateMachine.curResponse.freeSpinsInfo?.currentFreeSpinsGroup?.count || 0;

    this.freeSpinsCountScene.forEach((text) => (text.text = count.toString()));
    this.setFreeSpins(count);
  }
}
